import { render, staticRenderFns } from "./PuzzleCell.vue?vue&type=template&id=127606de&scoped=true"
import script from "./PuzzleCell.vue?vue&type=script&lang=js"
export * from "./PuzzleCell.vue?vue&type=script&lang=js"
import style0 from "./PuzzleCell.vue?vue&type=style&index=0&id=127606de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127606de",
  null
  
)

export default component.exports